var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.user_theme ? _vm.logo_wave_dark_anim : _vm.logo_wave_anim,"alt":_vm.env.image_alt}})}
var staticRenderFns = []

export { render, staticRenderFns }